/**
 * The linked event id on a document (US-37724).
 *
 * Estimate, WorkOrder and Invoice have all carried an `event` ObjectId for years —
 * API/models/Estimate/index.js:35, WorkOrder:50, Invoice:120 — and no client-portal read path
 * ever used it, so a client was never told the date their work was booked for.
 *
 * The ref may arrive as a bare id or, if a read path ever populates it, as an object. Both
 * shapes resolve to a string here so no caller has to care.
 */
export const eventIdOf = document => {
  const ref = document && document.event
  if (!ref) return null
  const id = ref._id || ref
  return typeof id === 'string' || typeof id === 'number' ? String(id) : null
}

/**
 * Is the client-facing scheduling surface switched on? US-38458.
 *
 * A function rather than an inline `!!flags?.schedulingWeb` at each call site because the rule
 * that matters is not obvious: an ABSENT key must read as off, and that is the live case rather
 * than a hypothetical one. API 7.1.5 in production carries no `schedulingWeb` key at all, so a
 * portal deployed against it receives flags with the key missing entirely — and until the flag
 * reaches every environment, `undefined` is what this actually sees.
 *
 * `featureFlags` itself is null on the confirm-link path: that page has no login, and this app
 * receives flags only in the login response. Callers there must NOT use this helper — they pass
 * `enabled` directly and rely on the core API's gate on /v6/portal/appointments/*. See
 * containers/AppointmentDetail.js.
 *
 * @param {Object|null} featureFlags  the login response's flags, straight off the app store
 * @returns {Boolean}
 */
export const isSchedulingEnabled = featureFlags =>
  featureFlags ? featureFlags.schedulingWeb === true : false

export default eventIdOf
